import { useMixPanel } from '../../../hooks/useMixPanel';
import { useMediaQuery } from 'react-responsive';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { MIX_PANEL_EVENTS } from '../../../utils/constans';
import useGlobalStore from '../../../store/useGlobalStore';
import ArrowLeft from '../icons/arrow-left';

const Breadcrumb = ({ backLabel, rootLabel, pageLabel }) => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { sendEvent } = useMixPanel();
  const { setCreditAnimateClear } = useGlobalStore();

  const backText = backLabel ? backLabel : 'inicio';
  const rootText = rootLabel ? rootLabel : 'classText1';
  const currentPageText = pageLabel
    ? pageLabel
    : 'formulario_bc_design_week_proyect_header';

  const trackBackEvent = () => {
    if (isMobile) {
      navigate('/');
    }
    setCreditAnimateClear();
    sendEvent(MIX_PANEL_EVENTS.classBackHome);
  };

  return (
    !isMobile && (
      <div className='w-full flex flex-row items-center lg:pt-4'>
        <Link
          to={'/'}
          className='font-bold text-sm text-shaiaBlue pr-4 border-r-2 border-shaiaBlue flex flex-row items-center gap-4 uppercase tracking-wider'
          onClick={trackBackEvent}
        >
          <ArrowLeft />
          {t(backText)}
        </Link>
        <div className='flex items-center gap-2 px-4 text-lg text-Grey-800 font-semibold'>
          <span>{t(rootText)}</span>/
          <span className='text-Grey-500 whitespace-nowrap'>{t(currentPageText)}</span>
        </div>
      </div>
    )
  );
};

export default Breadcrumb;
